import * as React from "react";
import {Icon, Label} from "semantic-ui-react";

import Button from "../../../components/Button";
import {FlagDto, OptionDto, OptionFlagMultiUpdateParamActionType} from "../../../services/Client";

import DataAdapterOptionsView from "../DataAdapterOptionsView";
import {SelectType} from "../workflowStatusMultiUpdate/WSMUSummaryUtils";
import {renderActionTypeLabel} from "./FlagActionSelection";
import {FMUSummaryTable} from "./FMUSummaryTable";

export interface FMUSummaryProps {
    actionType: OptionFlagMultiUpdateParamActionType;
    validItems: DataAdapterOptionsView[];
    t: reactI18Next.TranslationFunction;
    updatedFlags: FlagDto[];
    alreadyExistFlags: FlagDto[];
    // actions
    handleSelectChange: (actionType: SelectType, optionDto?: OptionDto, isChecked?: boolean) => void;
    nextAction: () => void;
    backAction: () => void;
}

interface FMUSummaryState {
    validTablePage: number;
}

export class FMUSummary extends React.Component<FMUSummaryProps, FMUSummaryState> {

    constructor(props: FMUSummaryProps) {
        super(props);

        this.state = {
            validTablePage: 1,
        };
    }

    render() {
        const { t, validItems, updatedFlags, handleSelectChange, alreadyExistFlags, actionType } = this.props;
        const totalItemsCount = validItems.length;
        let updatedFlagsCount;
        if (actionType === OptionFlagMultiUpdateParamActionType.ADD) {
            updatedFlagsCount = updatedFlags.length - alreadyExistFlags.length;
        } else if (actionType === OptionFlagMultiUpdateParamActionType.REMOVE) {
            updatedFlagsCount = alreadyExistFlags.length - updatedFlags.length;
        }

        return (
            <>

                <div style={{ marginBottom: '20px' }}>
                    <p>
                        <b>{this.props.t("PSL_WF_S_MULTI:ACTION_TYPE")}</b>
                        {': ' + renderActionTypeLabel(this.props.actionType, this.props.t)}
                    </p>

                    <p>
                        <b>{totalItemsCount}</b>
                        {' ' + t(totalItemsCount === 1 ? "PSL_WF_S_MULTI:ALL_ITEMS_COUNT_SINGLE" : "PSL_WF_S_MULTI:ALL_ITEMS_COUNT_MULTI")}
                    </p>
                    <p>
                        <b>{updatedFlagsCount}</b>
                        {' ' + t(updatedFlagsCount === 1 ? "PSL_FLAG_MULTI:NEW_FLAG_COUNT_SINGLE" : "PSL_FLAG_MULTI:NEW_FLAG_COUNT_MULTI")}
                    </p>
                </div>
                <div className={'scrollbarX'}>
                    <FMUSummaryTable
                        t={t}
                        actionType={this.props.actionType}
                        tablePage={this.state.validTablePage}
                        totalItems={validItems}
                        onChangePage={(pageNumber: number) => this.setState({ validTablePage: pageNumber })}
                        handleSelectChange={handleSelectChange}
                        updatedFlags={updatedFlags}
                        alreadyExistFlags={alreadyExistFlags}
                    />
                </div>

                <div style={{ marginTop: '30px' }}>
                    <Button
                        icon={'arrow left'}
                        onClick={this.props.backAction}
                    />
                    {this.props.validItems.length > 0 &&
                        <div style={{ float: 'right' }}>
                            {this.props.validItems.length === 0 &&
                                <Label color={'red'} pointing={'right'}>
                                    <Icon name={'warning'} />
                                    {this.props.t("PSL_WF_S_MULTI:EMPTY_LIST_HINT")}
                                </Label>}
                            <Button
                                icon={'arrow right'}
                                style={{ float: 'right' }}
                                disabled={this.props.validItems.length === 0 || validItems.filter(item => item.dto.isChecked).length === 0}
                                onClick={this.props.nextAction}
                            />
                        </div>
                    }
                </div>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/OptionsView/MultipleFlagUpdate/FMUSummary.tsx